import { getEnumValuesAsArray } from '@/core/utils/convert';
import { BlockReason } from '@/shared/models';
export function getBlockReasonIds(isTrackable) {
    const blockReasonIds = getEnumValuesAsArray(BlockReason);
    const result = isTrackable ? blockReasonIds : blockReasonIds.filter((reason) => reason !== BlockReason.TrackableQrCodeNotFound);
    return result;
}
